module.exports = __webpack_public_path__ + "static/media/07_plantilla_combo_cuadrada_fondo_6.e39882d0.jpg";